import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const BooleanAlgebra = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      title="Boolean Algebra: Basic definitions, Axiomatic definition of Boolean Algebra, Basic Theorems and Properties of Boolean Algebra"
      videos={[
        "https://www.youtube.com/embed/NqPhPiSer30?list=PLIY8eNdw5tW-yJHsxApeilNjX2Dkll-Ox",
        "https://www.youtube.com/embed/v8lyqjn6nqM",
      ]}
      takeaways={[]}
      questions={[]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default BooleanAlgebra;
